
import { BarChart2, Edit, Folder, FileText, Coffee, BookOpen, Users, Cpu, CalendarCheck, DollarSign, Video, UserCheck, Mic } from 'lucide-react';

export interface Task {
  name: string;
  icon: any; // Lucide icon component
}

export const energyTasks: Record<'power' | 'focus' | 'drift', Task[]> = {
  drift: [
    { name: 'User Feedback Session', icon: BarChart2 },
    { name: 'Brainstorming Jam', icon: Edit },
    { name: 'Team Sync', icon: Folder },
    { name: 'Casual Coffee Chat', icon: Coffee },
    { name: 'Mentorship Call', icon: BookOpen },
  ],
  focus: [
    { name: 'Product Planning Session', icon: FileText },
    { name: 'Technical Architecture Review', icon: Cpu },
    { name: 'Performance Analytics Review', icon: BarChart2 },
    { name: 'Financial Audit Meeting', icon: FileText },
    { name: 'Quarterly Planning', icon: CalendarCheck },
  ],
  power: [
    { name: 'Investor Pitch', icon: Users },
    { name: 'Sales Demo', icon: DollarSign },
    { name: 'Strategic Partnership', icon: Video },
    { name: 'Founder Intro', icon: UserCheck },
    { name: 'Podcast Interview', icon: Mic },
  ],
};